import React from 'react';
import { BadgeCheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const items = [{
  label: 'Compra 100% segura',
  icon: LockIcon,
  hide: ''
}, {
  label: 'Garantía de 7 días',
  icon: ShieldCheckIcon,
  hide: ''
}, {
  label: 'Acceso digital inmediato',
  icon: ZapIcon,
  hide: 'hidden sm:flex'
}, {
  label: 'Material profesional',
  icon: BadgeCheckIcon,
  hide: 'hidden md:flex'
}];
export function TrustBar() {
  return <div className="bg-petrol-900 text-petrol-100" data-id="element-403" data-mp="2mnifdyy4rgkg">
      <ul className="mx-auto flex max-w-6xl items-center justify-center gap-x-6 overflow-hidden px-4 py-2.5 text-[10px] font-semibold uppercase tracking-[0.14em] sm:gap-x-10 sm:text-[11px]" data-id="element-404" data-mp="2ilxaazru86kt">
        {items.map(({
        label,
        icon: Icon,
        hide
      }) => <li key={label} className={`flex shrink-0 items-center gap-1.5 whitespace-nowrap ${hide}`} data-id="element-405" data-mp="2rkr28cu848s1">
            <Icon className="h-3.5 w-3.5 text-gold-400" aria-hidden="true" data-id="element-406" data-mp="23uoeg8xcdoz8" />
            {label}
          </li>)}
      </ul>
    </div>;
}